var React = require('react');

function LuxeUnselected (props) {
    return React.createElement("svg",props,React.createElement("rect",{"x":"0.5","y":"0.5","width":"17","height":"17","rx":"8.5","stroke":"black"}));
}

LuxeUnselected.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = LuxeUnselected;

LuxeUnselected.default = LuxeUnselected;
